export default "<p>sweetalert works!</p>\n"